// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LogsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LogsIcon" ref={forwardedRef} {...props}>
      <path d="M16 7.5v9H7v-1H5.5V17a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5.554l-3.93-3.553L6.5 2a1 1 0 0 0-1 1v4.5H7v-4h4.75v4zM15.757 6H13.25V3.733z" />
      <path d="M1.39 8.9v5.6h3.304v-1.216h-1.96V8.9z" />
      <path d="M5.249 12.156c0 1.584.848 2.496 2.32 2.496 1.448 0 2.28-.936 2.28-2.552v-.904c0-1.56-.84-2.448-2.32-2.448-1.448 0-2.28.936-2.28 2.56zm2.296 1.28c-.616 0-.96-.464-.96-1.288v-.856c0-.848.352-1.328.968-1.328s.96.464.96 1.28V12.1c0 .856-.352 1.336-.968 1.336" />
      <path d="M10.581 12.188c0 1.472.88 2.464 2.408 2.464.672 0 1.376-.2 1.872-.68v-2.648h-1.936v1.112h.672l-.016.312v.632a1.7 1.7 0 0 1-.48.056c-.808 0-1.184-.568-1.184-1.296v-.792c0-.824.392-1.368 1.28-1.384a1.93 1.93 0 0 1 1.072.272l.456-1.008a3 3 0 0 0-1.672-.48c-1.352 0-2.472.72-2.472 2.52z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LogsIcon = /* @__PURE__ */ Object.assign(LogsIconComponent, {
  displayName: 'LogsIcon',
});
